const ARTICLE_STATUS = {
  UNCOMMITTED: 'Uncompleted',
  SUBMITTED: 'Submitted',
  PENDING_REVIEW: 'Pending Review',
  PENDING_RESUBMISSION: 'Pending Resubmission ',
  WITHDRAWN: 'Withdraw',
  REJECTED: 'Rejected',
  PENDING_MINOR_REVISIONS: 'Pending Minor Revision',
  PENDING_MAJOR_REVISIONS: 'Pending Major Revision',
  PAPER_ACCEPTED: 'Accepted',
  PENDING_DECISION: 'Pending Decision',
  RESUBMISSION: 'Resubmission',
  REVISED_REVIEW: 'Revised Review',
  PENDING_APC_CONFIRM: 'Pending APC Confirm',
  PENDING_PRE_CHECK: 'Pending Pre Check',
  PRE_CHECK_DONE: 'Pre Check Done',
  UNDER_REVIEW: 'Peer Review',
  PENDING_FIRST_DECISION: 'Pending First Decision',
  FIRST_DECISION_DONE: 'First Decision Done',
  PENDING_FINAL_DECISION: 'Pending Final Decision',
  FINAL_DECISION_DONE: 'Final Decision Done',
  ONLINE: 'Online'
}

// 邀请审稿人展示
const REVIEWER_STATUS = {
  NO_RESPONSE: 'No Response',
  AGREED: 'Agreed',
  DECLINED: 'Declined',
  COMPLETED: 'Completed',
  TERMINATED_BY_EDITOR: 'Canceled'
}

// 邀请外编状态显示
const ACADEMIC_STATUS = {
  PENDING_PRE_CHECK: 'Pending Pre Check',
  PRE_CHECK_DONE: 'Pre Check Done',
  PENDING_FIRST_DECISION: 'Pending First Decision',
  FIRST_DECISION_DONE: 'First Decision Done',
  PENDING_FINAL_DECISION: 'Pending Final Decision',
  FINAL_DECISION_DONE: 'Final Decision Done',
  TERMINATED_BY_EDITOR: 'Canceled'
}

// 决策展示
const DECISION_STATUS = {
  PAPER_ACCEPTED: 'Accept in Current Form',
  PENDING_MINOR_REVISIONS: 'Minor Revision',
  PENDING_MAJOR_REVISIONS: 'Major Revision',
  PEER_REVIEW: 'Send to Peer Review', //
  ACCEPT_CURRENT: 'Accept in Current Form', // 1
  ACCEPT_MINOR: 'Accept after Minor Revision',
  AFTER_MAJOR: 'Reconsider after Major Revision',
  REJECTED_OR_REST: 'Reject and Encourage Resubmission',
  REJECTED: 'Reject',
  WITHDRAWN: 'Withdraw'
}

// 编辑决策
const DECISION = {
  PAPER_ACCEPTED: 'Accept in Current Form',
  PENDING_MINOR_REVISIONS: 'Minor Revision',
  PENDING_MAJOR_REVISIONS: 'Major Revision',
  REJECTED: 'Reject',
  WITHDRAWN: 'Withdraw'
}

// 作者修订决策
const AUTHOR_REVISION = {
  PENDING_MINOR_REVISIONS: 'Minor Revision',
  PENDING_MAJOR_REVISIONS: 'Major Revision'
}

// 审稿人决策
const REVIEWER_DECISION = {
  PAPER_ACCEPTED: 'Accept in Current Form',
  PENDING_MINOR_REVISIONS: 'Minor Revision',
  PENDING_MAJOR_REVISIONS: 'Major Revision',
  REJECTED: 'Reject'
}

// 预审决策
const PRE_DECISION = {
  PEER_REVIEW: 'Send to Peer Review',
  // PENDING_MINOR_REVISIONS: 'Minor Revision',
  // PENDING_MAJOR_REVISIONS: 'Major Revision',
  REJECTED: 'Reject'
}

// 初审决策
const FIRST_DECISION = {
  ACCEPT_CURRENT: 'Accept in Current Form',
  ACCEPT_MINOR: 'Accept after Minor Revision',
  AFTER_MAJOR: 'Reconsider after Major Revision',
  REJECTED_OR_REST: 'Reject and Encourage Resubmission',
  REJECTED: 'Reject'
}

// 终审决策
const FINAL_DECISION = {
  ACCEPT_CURRENT: 'Accept in Current Form',
  ACCEPT_MINOR: 'Accept after Minor Revision',
  AFTER_MAJOR: 'Reconsider after Major Revision',
  REJECTED_OR_REST: 'Reject and Encourage Resubmission',
  REJECTED: 'Reject'
}

const AUTHOR_STATUS = {
  NO_RESPONSE: 'No Response',
  CONFIRMED: 'Confirmed',
  DECLINED: 'Declined'
}

const REJECTREASON = {
  '01': 'Not inerested in this manuscript',
  '02': 'Don’t have time for reviewing recently',
  '03': 'Manuscript is out of my research field'
}

// 邮件详情
const EMAILSTATUS = {
  PENDING: 'Pending',
  PROCESSED: 'Processed',
  DELIVERED: 'Delivered',
  FAILED: 'Failed'
}
// 邮件事件状态
const EMAILEVENT = {
  PROCESSED: 'Processed',
  DELIVERED: 'Delivered',
  DROPPED: 'Dropped',
  BOUNCE: 'Bounce',
  DEFERRED: 'Deferred'
}

// 操作类型
const OPERATIONTYPE = {
  ADD: 'Add',
  DELETE: 'Delete',
  VIEW: 'View',
  EDIT: 'Edit',
  IMPORT: 'Import',
  EXPORT: 'Export',
  DOWNLOAD: 'Download',
  ACCEPT: 'Accept',
  REFUSE: 'Refuse',
  PUBLISH: 'Publish/Unpublish',
  WITHDRAW: 'Withdraw/Cancel Withdraw'
}

// level
const JOURNAL_LEVEL = {
  SCI: 'SCI',
  EI: 'EI',
  CORE_JOURNAL: 'Core Journal',
  DEFAULT: 'Default'
}

// 出版商数据字典(通用)
const PUBLISHER_DICT_OPTION = {
  ACADEMIC_RANK: 'Academic Rank',
  DEGREE: 'Degree',
  EDITORIAL_BOARD_IDENTITY: 'Editorial Board Identity',
  GUEST_EDITOR_IDENTITY: 'Guest Editor Identity',
  HIGHEST_DEGREE: 'Highest degree',
  MANAGEMENT_TEAM_ROLE: 'Management Team Role',
  REVIEW_FREQUENCY: 'Review Frequency',
  REVIEWER_BOARD_IDENTITY: 'Reviewer Board Identity',
  REVIEWER_REFUSE_REASON: 'Reviewer Refuse Reason',
  SECTION_EDITOR_IDENTITY: 'Section Editor Identity',
  TITLE: 'Title',
  TOPIC_EDITOR_IDENTITY: 'Topic Editor Identity'
}

// 文件
const FILE_RESOURCE = {
  AUTHOR: 'AUTHOR',
  REVIEWER: 'REVIEWER',
  EDITOR_DECISION: 'EDITOR_DECISION',
  EDITOR_FINAL_DECISION: 'ME_DECISION',
  AUTHOR_REPLY: 'AUTHOR_REPLY',
  DECISION: 'EDITOR_DECISION_REVIEWER',
  FINAL_DECISION: 'EDITOR_DECISION_REVIEWER',
  FOR_REVIEWER: 'FOR_REVIEWER',
  PRE_CHECK: 'PRE_CHECK',
  FIRST_CHECK: 'FIRST_DECSION',
  FINAL_CHECK: 'FINAL_FIRST_DECSION',
  ACADEMIC_PRE_CHECK: 'ACADEMIC_PRE_CHECK',
  ACADEMIC_FIRST_CHECK: 'ACADEMIC_FIRST_DECSION',
  ACADEMIC_FINAL_CHECK: 'ACADEMIC_FINAL_DECSION',
  EDITOR_PRE_CHECK: 'EDITOR_PRE_CHECK',
  EDITOR_FIRST_CHECK: 'EDITOR_FIRST_DECSION',
  EDITOR_FINAL_CHECK: 'EDITOR_FINAL_DECSION',
  EDITOR_AUTHOR_REPLY: 'EDITOR_AUTHOR_REPLY'
}

const DISCOUNT_STATUS = {
  UNUSED: 'Unused',
  SELECTED: 'Selected',
  USED: 'Used',
  EXPIRED: 'Expired'
}

export {
  ARTICLE_STATUS,
  REVIEWER_STATUS,
  AUTHOR_REVISION,
  REVIEWER_DECISION,
  DECISION_STATUS,
  DECISION,
  AUTHOR_STATUS,
  REJECTREASON,
  PRE_DECISION,
  FIRST_DECISION,
  FINAL_DECISION,
  ACADEMIC_STATUS,
  EMAILSTATUS,
  OPERATIONTYPE,
  EMAILEVENT,
  JOURNAL_LEVEL,
  PUBLISHER_DICT_OPTION,
  FILE_RESOURCE,
  DISCOUNT_STATUS
}
